module.exports = __webpack_public_path__ + "img/hezuoqiyebg.679ba7e8.png";